import React, { FC } from 'react';
import { withRouter } from 'react-router';
import withLocalization from '../../hoc/withLocalization';
import './PackageCollapseDetails.scss';
import './PackageOverview.scss';
interface SearchPanelProps {
  localize?: any;
  localizeImages?: any;
  history: any;
  packageData: any;
}
const PackageOverviewSummary: FC<SearchPanelProps> = (props: SearchPanelProps) => {
  const { packageData, localize } = props;

  return (
    <>
      <div className="packageOverviewContentWrapper">
        {packageData?.retailVal && (
          <div className="packageCommonRow">
            <span className="packageHeaderContent">
              {localize('preview-sales-engine.static-content.copy.pbeo.retail-value-label')}
            </span>
            <span className="packageDescContent-bold">
              <s>{`${packageData?.retailVal}`}</s>
            </span>
          </div>
        )}
        <div className="packageCommonRow">
          <span className="packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.total-due-label')}
          </span>
          <span className="packageDescContent-bold">{`${packageData?.totalDue}`}</span>
        </div>
        <div className="packageOverviewDiveder"></div>
        <div className="packageCommonRow">
          <span className="new-packageHeaderContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.due-today-label')}
          </span>
          <span className="dueTodaycContent">{`${packageData?.dueToday}`}</span>
        </div>
        <div className="packageOverviewDiveder"></div>
        <div className="packageCommonRow">
          <span className="new-packagebalancerContent">
            {localize('preview-sales-engine.static-content.copy.pbeo.due-at-booking-label')}
          </span>
          <span className="packageDescContent-bold">{`${packageData?.dueAtBooking}`}</span>
        </div>
      </div>
    </>
  );
};
export default withRouter(withLocalization(PackageOverviewSummary));
